export const DEFAULT_PROJECT = "INTELLI_CROSS_DOCK"

export const USERS = {
	INTELLI_CONTROL_TOWER: ['abhishek.khale@intellibees.com', 'atul.deokar@intellibees.com']
}

export const PROJECTS = {
	INTELLI_CONTROL_TOWER: 'INTELLI_CONTROL_TOWER',
	INTELLI_CROSS_DOCK: 'INTELLI_CROSS_DOCK'
}

export function getLoggedInUser() {
	let user = localStorage.getItem('userdata')
	if(user && typeof user === "string") {
		user = JSON.parse(user)
		return user.username
	}
}

export function getUsersProject(userName) {
	for(let project in USERS) {
		if(USERS[project].includes(userName)) {
			return project
		}
	}

	return DEFAULT_PROJECT
}